import { apiClient } from 'api/apiClient';
import type { Summary } from 'legacy/lib/api/types/Summary';

const RESOURCE = '/vendors';

export const getVendors = async (filter?: string): Promise<Summary[]> => {
	const { data } = await apiClient.get(`${RESOURCE}/summaries${filter}`.trim());
	return data.results;
};
